import React from 'react'
import { RelatedQaItem } from './RelatedQaItem'
import AlertPanel from 'components/layout/search/AlertPanel'

const noVerifiedAlertTile = {
  title: 'Looks like we\'ve not found any good matches',
  message: 'Your search didn\'t return many close matches. Consider updating your search using the tips found by clicking the \u24D8 above.'
}

const lowResultCountAlertTile = {
  title: 'Looks like we\'ve not found many results',
  message: 'Your search returned only a few results. Consider updating your search using the tips found by clicking the \u24D8 above.'
}

export const RelatedQaSection = ({ flavour, selectedAols = [], smartSearchData: { verifiedAnswer, foundQa, lowResultAlert, lowScoreAlert } }) => {
  return (
    <div
      id='fc-smart-search-results'
      className='w-100 mhauto flex flex-column'
    >
      {verifiedAnswer &&
        <div className='mb10 w-100'>
          <RelatedQaItem {...{ flavour, q: verifiedAnswer }} verifiedAnswer />
        </div>}
      {lowScoreAlert && <AlertPanel {...noVerifiedAlertTile} />}
      <div className='mv7 flex flex-column w-100'>
        {foundQa.length > 0 && verifiedAnswer && (
          <span className='mb2 f4 fw5 db w-100 wb-word'>
            You might also be interested in these Q&As:
          </span>
        )}
        {foundQa.length > 0 && foundQa.map((tile, idx) => (
          <div className='mb3' key={tile.bookmarkId || idx}>
            <RelatedQaItem {...{ flavour, q: tile }} />
          </div>
        ))}
        {lowResultAlert && <AlertPanel {...lowResultCountAlertTile} />}
      </div>
    </div>
  )
}
